
  import { Component, Ref, Vue } from 'vue-property-decorator';
  import { Action } from 'vuex-class';

  import Generic from '../../types/app/generic/generic';
  import Endpoint from '../../utils/endpoint';

  @Component({})
  export default class TaxElection extends Vue {
    endpoint = new Endpoint();
    @Action('setSnackbar', { namespace: 'app' }) setSnackbar!: any;

    valid = null;
    saving = false;
    loading = false;
    rules = [
      v => !!v || 'This field is required'
      //v => (v && v.length <= 10) || 'Name must be less than 10 characters'
    ];
    isCreate = true;

    taxElection: Generic = {
      name: '',
      shortName: '',
      active: true
    };

    async created() {
      this.isCreate = !this.$route.params.id;
      if (!this.isCreate) {
        this.loading = true;
        await this.getTaxElection();
      }
    }

    get title(): string {
      return this.isCreate ? 'Create Tax Election' : 'Tax Election Detail';
    }

    async getTaxElection(): Promise<void> {
      this.loading = true;
      const response = await this.$http.get(`${this.endpoint.taxElection.getById}/${this.$route.params.id}`);

      if (response.status == 200) {
        this.taxElection = response.data.data;
        this.loading = false;
      }
    }

    async save(): Promise<void> {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        if (this.isCreate) {
          await this.create();
        } else {
          await this.update();
        }
      }
    }

    async update(): Promise<void> {
      this.saving = true;

      const response = await this.$http.put(
        `${this.endpoint.taxElection.update}/${this.$route.params.id}`,
        this.taxElection
      );

      if (response.status == 200) {
        this.saving = false;

        this.setSnackbar({
          show: true,
          message: 'Tax Election update',
          color: 'success'
        });

        this.$router.push({ name: 'IndexTaxElection' });
      } else {
        this.saving = false;
        console.log('erro...', response);
      }
    }

    async create(): Promise<void> {
      this.saving = true;

      const response = await this.$http.post(this.endpoint.taxElection.create, this.taxElection);

      if (response.status == 200) {
        this.saving = false;

        this.setSnackbar({
          show: true,
          message: 'Tax Election saved',
          color: 'success'
        });

        this.$router.push({ name: 'IndexTaxElection' });
      }

      if (response.status != 200) {
        this.saving = false;
      }
    }
  }
